export default __webpack_public_path__ + "static/media/oneup.ff79b4a9.png";